var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg14Circle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 340,
    viewBox: "0 0 343 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.501C0 9.45528 8.9543 0.500977 20 0.500977H43C208.685 0.500977 343 134.816 343 300.501V319.501C343 330.547 334.046 339.501 323 339.501H20C8.9543 339.501 0 330.547 0 319.501V20.501Z",
    fill: "#FFBE2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14Circle);
export default __webpack_public_path__ + "static/media/1-4-circle.3f9cb462bbf70b477bb91a137fdec288.svg";
export { ForwardRef as ReactComponent };